import React from 'react'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { spacingPx } from '@moonpig/launchpad-theme'

const StyledForm = styled.form.attrs<{
  isActive: boolean
}>(({ isActive }) => ({
  className: isActive ? 'is-active' : undefined,
}))<
  {
    isActive: boolean
  } & React.HTMLAttributes<HTMLFormElement>
>`
  ${({ theme, isActive }) =>
    s({
      height: { xs: '40px', md: spacingPx(12)({ theme }) },
      position: isActive ? { xs: 'fixed', md: 'relative' } : 'relative',
      top: isActive ? 0 : undefined,
      left: isActive ? 0 : undefined,
      width: isActive ? '100%' : undefined,
    })};

  &.is-active {
    z-index: 7;
    ${s({ bgcolor: 'colorBackground01' })}
  }
`

type Props = {
  isActive: boolean
  onFocus: (event: React.FocusEvent<HTMLFormElement>) => void
  children: React.ReactNode
} & React.HTMLAttributes<HTMLFormElement>

export const SearchForm = React.forwardRef<HTMLFormElement, Props>(
  ({ isActive, onFocus, children }, ref) => {
    return (
      <StyledForm
        ref={ref}
        data-testid="lp-nav-search-form"
        isActive={isActive}
        onFocus={onFocus}
      >
        {children}
      </StyledForm>
    )
  },
)
SearchForm.displayName = 'SearchForm'
